import { ReactElement, useEffect, useState } from 'react'
import {
  FlexWrapper,
  PageWrapper,
  SectionTitle,
  TableWrapper,
  TableHeader,
  TableFooter,
  Input,
  Button,
  Loader,
  Modal,
  DropdownWrapper,
  EditableDropdown,
  TostMessage
} from '../../../../components'
import strings from '../../../../locale/en'
import Table from 'react-bootstrap/Table'
import { TableRow, Icon } from './subcomponents'
import { tableHeader, initialState } from './const'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import {
  getQrCodeList,
  selectQrCode,
  selectAllQrCode,
  deSelectAllQrCode,
  manageQrCode,
  resetError
} from '../../../../redux/qrCode/actions'
import { RootState } from '../../../../redux/store'
import { QrCodeInfo } from '../../../../redux/qrCode/typings'
import { getChildCourses, getCourse } from '../../../../redux/course/action'
import getCoursesDropdown, {
  getAllCoursesDropdown
} from '../../../../helpers/getCoursesDropdown'
import InputGroup from 'react-bootstrap/InputGroup'
import { FormBackWrapper } from '../../User/subcomponents'

const QrList = (): ReactElement => {
  const [filter, setFilter] = useState('')
  const [assignCourse, setAssignCourse] = useState(false)
  const [qrCodeForm, setQrCodeForm] = useState(initialState)

  const {
    qrcode: { content, totalPages, number, isLoading, error },
    course: { courseDetails, subjects, chapters, topics }
  } = useSelector((state: RootState) => state, shallowEqual)

  const pageNumber = number + 1
  const dispatch = useDispatch()
  const courseList = courseDetails ? getAllCoursesDropdown(courseDetails) : []
  const subjectList = subjects ? getCoursesDropdown(subjects) : []
  const chapterList = chapters ? getCoursesDropdown(chapters) : []
  const topicsList = chapters ? getCoursesDropdown(topics) : []
  const canAssign =
    qrCodeForm.courseId &&
    qrCodeForm.chapterId &&
    qrCodeForm.subjectId &&
    qrCodeForm.topicId

  const {
    menu: {
      admin: {
        qrCode: {
          list: { title, search, assignCourseModal }
        }
      }
    },
    button: { assign, selectAll, dSelectAll }
  } = strings

  const filterQrList = filter
    ? content.filter((qrInfo: QrCodeInfo) => qrInfo?.videoUrl?.includes(filter))
    : content

  const selectedQrCodeList = filterQrList
    .filter((qrCode: QrCodeInfo) => qrCode?.isSelected)
    .map((qrCode: QrCodeInfo) => qrCode?.qrCodePath)

  useEffect(() => {
    dispatch(getQrCodeList(1))
    dispatch(getCourse())

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <FlexWrapper justifyContent="space-between" hasBorder>
        <SectionTitle title={title} />
      </FlexWrapper>
      <TostMessage
        show={!!error}
        onCloseHandler={() => dispatch(resetError())}
        message={error}
      ></TostMessage>
      <FlexWrapper noPadding>
        <Input
          width="30%"
          label={search}
          value={filter}
          name={'filter-subject'}
          onChange={(value) => {
            setFilter(value)
          }}
          hasPadding={false}
        />
        <Button
          onClick={() => {
            if (selectedQrCodeList.length > 0) {
              setAssignCourse(true)
            } else {
              dispatch(selectAllQrCode())
            }
          }}
        >
          {selectedQrCodeList.length > 0 ? assign : selectAll}
        </Button>
        {selectedQrCodeList.length > 0 && (
          <Button
            onClick={() => {
              dispatch(deSelectAllQrCode())
            }}
          >
            {dSelectAll}
          </Button>
        )}
      </FlexWrapper>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <FormBackWrapper>
            <TableWrapper>
              <Table responsive="sm" size="sm">
                <TableHeader>
                  <TableRow>
                    {tableHeader?.map((header, index) => (
                      <th key={`qrcode-list-header-${index}`}>{header}</th>
                    ))}
                  </TableRow>
                </TableHeader>
                <tbody>
                  {filterQrList.map((qrCode: QrCodeInfo, index) => {
                    return (
                      <TableRow key={`qr-code-${index}`}>
                        <td>
                          <InputGroup.Checkbox
                        
                            checked={qrCode.isSelected}
                            onChange={() => {
                              dispatch(
                                selectQrCode({
                                  id: qrCode?.id
                                })
                              )
                              // setSelectAll(!qrCode.isSelected)
                            }}
                          />
                        </td>
                        <td>{qrCode?.id}</td>
                        <td>{qrCode?.videoUrl}</td>
                        <td>
                          <div>
                            <Icon
                              variant="outline-light"
                              onClick={() => { }}
                              disabled={filter}
                            >
                              <FontAwesomeIcon
                                icon={['far', 'eye']}
                                style={{
                                  marginRight: 10
                                }}
                              />
                            </Icon>
                          </div>
                        </td>
                      </TableRow>
                    )
                  })}
                </tbody>
              </Table>
              <TableFooter
                currentPage={pageNumber}
                totalPages={totalPages}
                handleNext={() => dispatch(getQrCodeList(pageNumber + 1))}
                handlePrevious={() => dispatch(getQrCodeList(pageNumber - 1))}
              />
            </TableWrapper>
          </FormBackWrapper>
        </div>
      )}
      {assignCourse && (
        <Modal
          disableSubmit={!canAssign}
          handleCancel={() => {
            setAssignCourse(false)
          }}
          handleSubmit={() => {
            setAssignCourse(false)
            const qrCodeList = filterQrList
              .filter((qrCode: QrCodeInfo) => qrCode?.isSelected)
              .map((qrCode: QrCodeInfo) => qrCode?.qrCodePath)

            dispatch(
              manageQrCode({
                qrCodePath: qrCodeList,
                courseId: [qrCodeForm.courseId],
                subjectId: [qrCodeForm.subjectId],
                chapterId: [qrCodeForm.chapterId],
                topicId: [qrCodeForm.topicId]
              })
            )
          }}
          title={assignCourseModal}
        >
          <FlexWrapper>
            <DropdownWrapper width="100%">
              <EditableDropdown
                width="100%"
                dropdownList={courseList}
                isRequired
                handleSelect={(item) => {
                  dispatch(
                    getChildCourses({
                      courseId: item?.id,
                      type: 'SUBJECT'
                    })
                  )
                  setQrCodeForm({
                    ...qrCodeForm,
                    courseId: item?.id
                  })
                }}
                placeholder={strings.menu.admin.selectCourse}
              />
            </DropdownWrapper>
            {subjectList.length > 0 && (
              <DropdownWrapper width="100%">
                <EditableDropdown
                  width="100%"
                  dropdownList={subjectList}
                  isRequired
                  handleSelect={(item) => {
                    dispatch(
                      getChildCourses({
                        courseId: item?.id,
                        type: 'CHAPTER'
                      })
                    )
                    setQrCodeForm({
                      ...qrCodeForm,
                      subjectId: item?.id
                    })
                  }}
                  placeholder={strings.menu.admin.selectSubject}
                />
              </DropdownWrapper>
            )}
            {chapterList.length > 0 && (
              <DropdownWrapper width="100%">
                <EditableDropdown
                  width="100%"
                  dropdownList={chapterList}
                  isRequired
                  handleSelect={(item) => {
                    dispatch(
                      getChildCourses({
                        courseId: item?.id,
                        type: 'TOPICS'
                      })
                    )
                    setQrCodeForm({
                      ...qrCodeForm,
                      chapterId: item?.id
                    })
                  }}
                  placeholder={strings.menu.admin.selectChapter}
                />
              </DropdownWrapper>
            )}
            {topicsList.length > 0 && (
              <DropdownWrapper width="100%">
                <EditableDropdown
                  width="100%"
                  dropdownList={topicsList}
                  isRequired
                  handleSelect={(item) => {
                    setQrCodeForm({
                      ...qrCodeForm,
                      topicId: item?.id
                    })
                  }}
                  placeholder={strings.menu.admin.selectTopic}
                />
              </DropdownWrapper>
            )}
          </FlexWrapper>
        </Modal>
      )}
    </PageWrapper>
  )
}

export default QrList
